// src/components/MemberMaint2.jsx

import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
import NewUserSubscriptionView from './NewUserSubscriptionView';
import ActiveMemberView from './ActiveMemberView'; // We are now importing the real component

const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-xl font-semibold">Loading Your Membership...</div>
  </div>
);

function MemberMaint2() {
  const { supabase, fetchWrapper, membership, membershipLoaded } = useAuth();
  const [products, setProducts] = useState({ subscriptions: [], creditPacks: [] });
  const [isLoadingProducts, setIsLoadingProducts] = useState(true);

  // 1. One-time fetch for all products from 'tiers'
  // Corrected useEffect using fetchWrapper and existing RPC
  useEffect(() => {
    const fetchProducts = async () => {
      setIsLoadingProducts(true);
      try {
        // --- CORRECTED FETCH ---
        // Use fetchWrapper to call the existing RPC
        const response = await fetchWrapper(
          `${process.env.REACT_APP_API_URL}/supabase/rpc/get_tiers`, // Endpoint for your RPC
          {
            method: 'POST', // Assuming POST for RPCs
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({}), // Empty body - RPC takes no arguments
            // Add credentials/CSRF if your wrapper handles them
          }
        );

        // Process the response (adjust based on how fetchWrapper returns data/errors)
        const data = await response.json();

        if (!response.ok || !Array.isArray(data)) {
            // Check response.ok or look for an error property from fetchWrapper
            console.error("Error fetching products via RPC:", data);
            throw new Error('Failed to fetch products');
        }
        // --- END CORRECTED FETCH ---

        // Sort data (same as before)
        setProducts({
          subscriptions: data.filter(p => p.is_membership === true),
          creditPacks: data.filter(p => p.is_membership === false)
        });

      } catch (error) {
         console.error("Error in fetchProducts:", error);
         // Optionally set an error state here to show the user
      } finally {
        setIsLoadingProducts(false);
      }
    };

    // Only fetch if fetchWrapper is available
    if (fetchWrapper) {
        fetchProducts();
    } else {
        console.error("fetchWrapper is not available from AuthContext!");
        setIsLoadingProducts(false); // Stop loading if wrapper is missing
    }
    // Dependency array includes fetchWrapper (assuming it's stable via useCallback)
  }, [fetchWrapper]);



  // 2. The "View Router"
  const renderCurrentView = () => {
    const urlParams = new URLSearchParams(window.location.search);
  const success = urlParams.get('success');
  if (success === 'false') {
    return (
      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-6 text-center">
        <strong>Cancelled:</strong> Your purchase was cancelled. <button onClick={() => window.history.back()} className="ml-2 underline">Go Back</button>
      </div>
    );
  }
    if (!membershipLoaded || isLoadingProducts) {
      return <LoadingSpinner />;
    }

    // --- THE STATE MACHINE ---

    // SCENARIO 1: New user (or any state that isn't active/cancelling)
    // Your logic: "he will be present to purchase one of 3 subscriptions or choose a one month limited free membership"
    if (membership.status === 'no_membership' ) {
      return (
        <NewUserSubscriptionView 
          subscriptionProducts={products.subscriptions}
          creditPackProducts={products.creditPacks}
          showFreeTrial={membership.status === 'no_membership'} // Only show free trial if status is 'no_membership'
        />
      );
    }
    
    // SCENARIO 2: Active or Cancelling user
    // They see the full management page.
    if (membership.status === 'active' || membership.status === 'cancelling' || membership.status === 'expired' || membership.status === 'cancelled') {
      return (
        <ActiveMemberView
          subscriptionProducts={products.subscriptions}
          creditPackProducts={products.creditPacks}
          currentMembership={membership}
        />
      );
    }

    // Fallback for any other status
    return <LoadingSpinner />;
  };

  return (
    <div className="member-maintenance-container bg-gray-50 min-h-screen">
      {renderCurrentView()}
    </div>
  );
}

export default MemberMaint2;